export interface Scene {
  id: number;
  typeId: number[];
  name: string;
  img: string;
  desc: string;
  recorder: {
    componentsList: any[];
  };
  requestData: any;
}

export const sceneList: Scene[] = [
  {
    id: 1,
    typeId: [1, 2, 4],
    name: '小红书通用文案',
    img: require('@/assets/images/copywriting-assistant/xiaohongshulogo.png'),
    desc: '一键拿捏小红书流量密码',
    recorder: {
      // 组件列表
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'titles',
          tip: '简单说说你的文案内容',
          isRequired: true,
          componentProps: {
            placeholder: '广州三日游玩',
            maxlength: 500,
            showWordLimit: true,
            type: 'textarea',
            rows: 10,
          },
        },
        {
          type: 'radio',
          label: '字数限制',
          value: '',
          key: 'numbers',
          tip: '生成内容的字数范围',
          options: [
            { label: '不限', value: '' },
            { label: '100', value: '100' },
            { label: '200', value: '200' },
            { label: '500', value: '500' },
          ],
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-kPLOzluLwPVdtZC4KBnr3c2f',
      },
    },
  },
  {
    id: 2,
    typeId: [1, 2, 4],
    name: '仿写爆款文案',
    img: require('@/assets/images/copywriting-assistant/xiaohongshulogo.png'),
    desc: '一键仿写别人的爆款笔记',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'title',
          tip: '你想写的主题内容',
          componentProps: {
            maxlength: 100,
            showWordLimit: true,
            placeholder: '夏日防晒遮阳帽',
            type: 'text',
          },
        },
        {
          type: 'input',
          value: '',
          key: 'text',
          tip: '想仿写哪篇笔记？把内容复制过来',
          componentProps: {
            maxlength: 800,
            showWordLimit: true,
            rows: 26,
            placeholder:
              '【悠闲夏日必备！】遮阳帽：留下阳光，拒绝晒黑！夏天的阳光如此明媚，却总是让人苦恼晒黑。不害怕，从现在开始，我把晒黑的坏运气通通带走！遮阳帽，拒绝晒黑首选，让我们一同展开纷飞的小伞，享受悠闲夏日吧！ 【轻盈呵护】：躲烈日，不躲风。遮阳帽的轻便设计使你不必再因为想要遮阳而舍弃轻风的拥抱。百变的风格和贴心的设计，让你在炎炎夏日依然能轻松摘取清爽。【时尚元素】：遮阳帽不只是保护你的肌肤，更是个性的时尚标配！从日系清新、田园花苞，到街头潮流、运动风，总有一款适合你的遮阳帽能展示你的独特魅力！保护皮肤，时尚不输！【多用途防护】：遮阳帽不仅可以挡住烈日的炙烤，还能为你提供更多贴心的防护。无论是郊游还是海滩度假，遮阳帽都能隔绝紫外线的伤害，为你的大脑加上一把防晒伞。让我们进入遮阳帽的保护伞下，安享健康生活！【趣味造型】：遮阳帽的好玩之处还在于其无限变化的造型！从可爱的果冻贝雷帽，到时髦的渔夫帽，再到经典的草帽，遮阳帽的形状与颜色丰富多样，总能为你带来快乐的穿搭新灵感！改头换帽，成为夏日中最靓丽的风景！【实用时尚】：遮阳帽既有时尚的外表，更兼备实用的功能。无论是户外露营、郊游烧烤，还是购物逛街、追逐潮流，遮阳帽都能为你提供全方位的保护，让你在享受夏日的同时，也能保持时尚态度！',
            type: 'textarea',
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-9GMwoDyzpfFGwfeFeK6hGpub',
      },
    },
  },
  {
    id: 3,
    typeId: [1, 2, 4],
    name: '小红书种草文',
    img: require('@/assets/images/copywriting-assistant/xiaohongshulogo.png'),
    desc: '一看就种草，看完就下单，都烂拦不住',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'name',
          tip: '你的产品是什么',
          componentProps: {
            maxlength: 200,
            showWordLimit: true,
            placeholder: '面霜',
            type: 'text',
          },
        },
        {
          type: 'input',
          value: '',
          key: 'text',
          tip: '你的卖点是什么',
          componentProps: {
            maxlength: 300,
            showWordLimit: true,
            placeholder: '可以紧肤焕白，淡化皱纹',
            type: 'textarea',
            rows: 10,
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-ANGM08JoYZLcLjPRQKlODxM1',
      },
    },
  },
  {
    id: 4,
    typeId: [1, 4],
    name: '微博推文',
    img: require('@/assets/images/copywriting-assistant/weibologo.png'),
    desc: '博主和品牌方都爱用',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'theme',
          tip: '主题描述',
          componentProps: {
            maxlength: 200,
            showWordLimit: true,
            placeholder: '那英送何炅的衣服竟然是童装',
            type: 'textarea',
            rows: 10,
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-Z8vuqwILZZiiTy3H95ADEqa7',
      },
    },
  },
  {
    id: 5,
    typeId: [1, 4],
    name: '公众号创作',
    img: require('@/assets/images/copywriting-assistant/gongzhonghaologo.png'),
    desc: '微信公众号文章图文创作',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'theme',
          tip: '主题描述',
          componentProps: {
            maxlength: 300,
            showWordLimit: true,
            placeholder: '这种维生素10个人里9个缺，可能引起疲劳、暴躁、皮肤差...',
            type: 'textarea',
            rows: 10,
          },
        },
        {
          type: 'input',
          value: '',
          key: 'tips',
          tip: '推文要求/补充说明',
          componentProps: {
            maxlength: 300,
            showWordLimit: true,
            placeholder: '要求文章中必须有维生素的成分',
            type: 'textarea',
            rows: 10,
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-wHovBOzgR5DtRShkElQ9CFls',
      },
    },
  },
  // {
  //   id: 6,
  //   typeId: [1],
  //   name: 'AI翻译',
  //   img: require('@/assets/images/copywriting-assistant/fanyilogo.png'),
  //   desc: '遥遥领先，超越市面上任何翻译工具',
  //   recorder: {
  //     componentsList: [
  //       {
  //         type: 'input',
  //         value: '',
  //         key: 'text',
  //         tip: '输入要翻译的内容',
  //         componentProps: {
  //           maxlength: 800,
  //           showWordLimit: true,
  //           placeholder:
  //             '中文里有一个人们耳熟能详的词——“走马观花”，字面意思是“骑在疾驰的马上看花”，也有“概览一份详实的记述”“忙于生计以致忽略了让生活更有意义的小美好”等诸多词义',
  //           type: 'textarea',
  //           rows: 10,
  //         },
  //       },
  //       {
  //         type: 'select',
  //         value: '英语',
  //         key: 'language',
  //         tip: '选择目标语言',
  //         options: [
  //           { label: '中文', value: '中文' },
  //           { label: '英语', value: '英语' },
  //           { label: '日语', value: '日语' },
  //           { label: '韩语', value: '韩语' },
  //           { label: '法语', value: '法语' },
  //           { label: '德语', value: '德语' },
  //           { label: '俄语', value: '俄语' },
  //           { label: '泰语', value: '泰语' },
  //           { label: '意大利语', value: '意大利语' },
  //           { label: '葡萄牙语', value: '葡萄牙语' },
  //           { label: '阿拉伯语', value: '阿拉伯语' },
  //           { label: '西班牙语', value: '西班牙语' },
  //         ],
  //       },
  //     ],
  //   },
  //   requestData: {
  //     url: '/ai/v1/workflows/run',
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer app-7pmFn0OnclmgAZ2bqnn0J20O',
  //     },
  //   },
  // },
  {
    id: 7,
    typeId: [1, 5],
    name: '营销文案',
    img: require('@/assets/images/copywriting-assistant/yingxiaologo.png'),
    desc: '生成一段戳中用户痛点，激发购买欲望的文案',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'info',
          tip: '说说你的产品或宣传需求',
          componentProps: {
            maxlength: 300,
            showWordLimit: true,
            placeholder: '灵泽万川Ai，让AI成为你的营销专家',
            type: 'textarea',
            rows: 10,
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-Qi3LxFS5HiwNcgHz76RLrDbG',
      },
    },
  },
  {
    id: 8,
    typeId: [1, 5],
    name: '朋友圈营销',
    img: require('@/assets/images/copywriting-assistant/pengyouquanlogo.png'),
    desc: '随心定制各类营销文案，发圈必备',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'titles',
          tip: '营销内容',
          componentProps: {
            maxlength: 300,
            showWordLimit: true,
            placeholder: '介绍灵泽万川保湿滋润面膜，超强锁水能力，亲肤植物萃取成分，一膜双效温柔修复敏感肌肤',
            type: 'textarea',
            rows: 10,
          },
        },
        {
          type: 'radio',
          label: '字数限制',
          value: '',
          key: 'numbers',
          tip: '生成内容的字数范围',
          options: [
            { label: '不限', value: '' },
            { label: '100', value: '100' },
            { label: '200', value: '200' },
            { label: '500', value: '500' },
          ],
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-kPLOzluLwPVdtZC4KBnr3c2f',
      },
    },
  },
  {
    id: 9,
    typeId: [1, 4, 5],
    name: '电商文案',
    img: require('@/assets/images/copywriting-assistant/taobaologo.png'),
    desc: '无需在为电商文案烦恼，一键生成',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'product',
          tip: '简约北欧风实木衣帽架',
          componentProps: {
            maxlength: 100,
            showWordLimit: true,
            placeholder: '简约北欧风实木衣帽架',
            type: 'text',
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-RJ7UbSnxMMmZoXbTyoV4oZ8A',
      },
    },
  },
  {
    id: 10,
    typeId: [1, 3],
    name: '剧情视频脚本',
    img: require('@/assets/images/copywriting-assistant/douyinlogo.png'),
    desc: '秒变剧本大师，轻松创作爆款视频脚本',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'videotheme',
          tip: '视频主题',
          componentProps: {
            maxlength: 200,
            showWordLimit: true,
            placeholder: '社恐人的职场生存指南',
            type: 'text',
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-tEaV63fvrQioQVrIP1OgKEy4',
      },
    },
  },
  {
    id: 11,
    typeId: [1, 3],
    name: '抖音视频大纲',
    img: require('@/assets/images/copywriting-assistant/douyinlogo.png'),
    desc: '一份优秀的抖音视频大纲，让视频创作事半功倍',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'focus',
          tip: '视频主题',
          componentProps: {
            maxlength: 300,
            showWordLimit: true,
            placeholder: '教你如何在潘家园淘到宝贝',
            type: 'textarea',
            rows: 10,
          },
        },
        {
          type: 'input',
          value: '',
          key: 'info',
          tip: '补充说明/其他要求',
          componentProps: {
            maxlength: 300,
            showWordLimit: true,
            placeholder: '要求视频中必须有潘家园的场景',
            type: 'textarea',
            rows: 10,
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-CQeahSSiZ35sXK408P45O1Vg',
      },
    },
  },
  {
    id: 12,
    typeId: [1, 3],
    name: '抖音视频文案',
    img: require('@/assets/images/copywriting-assistant/douyinlogo.png'),
    desc: '秒变剧本大师，轻松创作爆款视频脚本',
    recorder: {
      componentsList: [
        {
          type: 'input',
          value: '',
          key: 'text_themes',
          tip: '文案主题',
          componentProps: {
            maxlength: 100,
            showWordLimit: true,
            placeholder: '润唇膏',
            type: 'text',
          },
        },
        {
          type: 'input',
          value: '',
          key: 'content_points',
          tip: '文案要求',
          componentProps: {
            maxlength: 800,
            showWordLimit: true,
            placeholder:
              '润唇膏不仅可以润唇，还有多种妙用，如滋润甲床、软化死皮、抚平发丝、淡化细纹等选择不含荧光剂、香精、酒精、防腐剂等成分的润唇膏',
            type: 'textarea',
            rows: 20,
          },
        },
      ],
    },
    requestData: {
      url: '/ai/v1/workflows/run',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer app-7JqqvyolIEww22QZ27vGY3ys',
      },
    },
  },
];
